var map = {
	"../auction/bid/bid.module": [
		"./src/app/auction/bid/bid.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-survey-survey-module",
		"common",
		"auction-bid-bid-module"
	],
	"../auction/form/form.module": [
		"./src/app/auction/form/form.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-survey-survey-module",
		"auction-auction-module~auction-form-form-module~form-form-module",
		"auction-form-form-module~form-form-module",
		"common",
		"auction-form-form-module"
	],
	"../auction/survey/survey.module": [
		"./src/app/auction/survey/survey.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-survey-survey-module",
		"common",
		"auction-survey-survey-module"
	],
	"./answer/answer.module": [
		"./src/app/purchase-project/answer/answer.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"answer-answer-module~ca-display-ca-display-module",
		"common",
		"answer-answer-module"
	],
	"./auction/auction.module": [
		"./src/app/auction/auction.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-survey-survey-module",
		"auction-auction-module~auction-form-form-module~form-form-module",
		"common",
		"auction-auction-module"
	],
	"./ca-display/ca-display.module": [
		"./src/app/purchase-project/display/ca-display/ca-display.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"answer-answer-module~ca-display-ca-display-module",
		"common",
		"ca-display-ca-display-module"
	],
	"./display/display.module": [
		"./src/app/purchase-project/display/display.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"common",
		"display-display-module"
	],
	"./form/form.module": [
		"./src/app/purchase-project/form/form.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"auction-auction-module~auction-form-form-module~form-form-module",
		"auction-form-form-module~form-form-module",
		"form-form-module~na-display-na-display-module",
		"common",
		"form-form-module"
	],
	"./na-display/na-display.module": [
		"./src/app/purchase-project/display/na-display/na-display.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"form-form-module~na-display-na-display-module",
		"common",
		"na-display-na-display-module"
	],
	"./purchase-project/purchase-project.module": [
		"./src/app/purchase-project/purchase-project.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-auction-module~ca-display-ca-display-module~form-form-module~na-display~ee2b9929",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"common",
		"purchase-project-purchase-project-module"
	],
	"./update/update.module": [
		"./src/app/purchase-project/update/update.module.ts",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~70e0d02c",
		"answer-answer-module~auction-auction-module~auction-bid-bid-module~auction-form-form-module~auction-~e585c871",
		"answer-answer-module~ca-display-ca-display-module~display-display-module~form-form-module~na-display~750f0961",
		"answer-answer-module~auction-form-form-module~form-form-module~na-display-na-display-module~purchase~181b0b8f",
		"common",
		"update-update-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;